export const TABLE_HEADINGS = [
  { lg: 6, title: 'Carrier' },
  { lg: 3, title: 'Carrier Id' },
  { lg: 2, title: 'Services' },
  { lg: 1, title: '' }
];

export const MODAL_TYPES = {
  TOGGLE: 'TOGGLE',
  CONFIG: 'CONFIG'
};
